import { render, staticRenderFns } from "./card-tertiary.vue?vue&type=template&id=e9100808&scoped=true&"
import script from "./card-tertiary.vue?vue&type=script&lang=js&"
export * from "./card-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9100808",
  null
  
)

export default component.exports